export function openUrl(url: string) {
  if (typeof window === 'undefined') {
    return;
  }

  const urlToOpen = new URL(url, window.location.toString()).toString();
  window.open(urlToOpen, '_blank', 'noopener');
}
